import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 30px;
  position: relative;

  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;

export const Grid = styled.div`
  margin-top: 20px;
  padding: 30px 50px;
  background-color: ${theme.colors.darkBlue};
  border-radius: 40px 0 0 40px;

  display: flex;
  flex-direction: column;

  overflow-y: auto;

  font-family: ${theme.font.poppins};
  color: white;

  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.darkBlue};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800};
  }

  .row {
    display: flex;
    width: 100%;
  }

  .row div {
    padding: 10px;
  }

  .row div:not(.row-title) {
    flex: 1;
    text-align: center;
  }

  .row-title {
    flex: 2;
    text-align: left;
  }

  .header {
    .plan {
      display: flex;
      flex-direction: column;
      align-items: center;

      .plan-title {
        color: ${theme.colors.blue100};
      }

      .plan-value {
        color: ${theme.colors.white};
        font-size: ${theme.font.sizes.medium};
        font-weight: ${theme.font.bold};
      }
    }
  }

  .row:nth-of-type(2n + 3):not(:last-of-type) {
    background-color: ${theme.colors.blue900};
    border-radius: ${theme.border.normal};
    color: ${theme.colors.gray400};
  }

  .middle {
    background-color: ${theme.colors.blue100};
    color: ${theme.colors.darkBlue};

    .plan-title,
    .plan-value {
      color: ${theme.colors.darkBlue} !important;
    }

    path {
      fill: ${theme.colors.darkBlue} !important;
    }
  }

  .header {
    .middle {
      border-radius: ${theme.border.mediumRadius} ${theme.border.mediumRadius} 0
        0;
    }
  }

  .button {
    border-radius: 0 0 ${theme.border.mediumRadius} ${theme.border.mediumRadius};

    button {
      border: 1px solid ${theme.colors.darkBlue} !important;
      color: ${theme.colors.darkBlue} !important;
    }
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const MobileGrid = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  overflow-y: auto;

  @media screen and (min-width: 768px) {
    display: none;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 12px 14px;
  width: 100%;
  background-color: ${theme.colors.blue400};
  border-radius: ${theme.border.xradius};
  margin-bottom: 10px;
  border: 1px solid ${theme.colors.blue400};

  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};

  &:nth-of-type(2) {
    background-color: ${theme.colors.blue100};
    color: ${theme.colors.darkBlue};
    border: 1px solid ${theme.colors.blue100};
  }

  &:last-of-type {
    margin-bottom: 0;
    background-color: ${theme.colors.darkBlue};
  }
`;

export const MobileButton = styled.button`
  width: 100%;
  text-align: center;
  margin-top: 10px;
  padding: 16px 0;
  background-color: ${(props) =>
    props.className?.includes("invert-color")
      ? theme.colors.darkBlue
      : theme.colors.blue100};

  color: ${(props) =>
    props.className?.includes("invert-color")
      ? theme.colors.blue100
      : theme.colors.darkBlue};
  border-radius: ${theme.border.normal};
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.semiBold};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const PlanName = styled.h2`
  font-size: 12px;
  font-weight: ${theme.font.normal};
  color: ${(props) =>
    props.className?.includes("middle")
      ? theme.colors.darkBlue
      : theme.colors.blue100};
`;

export const PlanPrice = styled.h3`
  font-size: 24px;
  font-weight: ${theme.font.bold};
  color: ${(props) =>
    props.className?.includes("middle")
      ? theme.colors.darkBlue
      : theme.colors.white};
`;

export const MobileRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
  color: ${(props) =>
    props.className?.includes("middle")
      ? theme.colors.darkBlue
      : theme.colors.white};

  &:nth-of-type(2n + 3) {
    color: ${(props) =>
      props.className?.includes("middle")
        ? theme.colors.gray700
        : theme.colors.gray400};
  }

  svg[class="middle"] {
    path {
      fill: ${theme.colors.darkBlue};
    }
  }
`;

export const Button = styled.button`
  background-color: transparent;
  border: 1px solid ${theme.colors.blue100};
  font-size: 12px;
  font-weight: normal;
  padding: 10px 12px;
  color: ${theme.colors.blue100};
  border-radius: ${theme.border.xradius};
`;

export const SpinnerWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
